import React from 'react';
import Navbar from '../Navbar/Navbar';
import Policy from '../Policy/Policy';
import Footer from '../Footer/Footer';

const PolicyPage = () => {
  return (
    <div className='policy-page'>
      <Navbar />
      <Policy />
      <Footer />
    </div>
  );
};

export default PolicyPage;
